module.exports = __webpack_public_path__ + "static/media/bake.b75de952.mp3";